import type { BadgeProps } from 'antd'

import type { SupportTicket } from 'src/api/main'

const STATUS_BADGE_MAP: Record<string, BadgeProps['status']> = {
  OPEN: 'default',
  'IN PROGRESS': 'processing',
  PENDING: 'warning',
  SOLVED: 'success',
  COMPLETED: 'success'
}

export const normalizeTicketStatus = (status: string): string =>
  status.replace(/_/g, ' ').replace(/\s+/g, ' ').trim().toUpperCase()

export const resolveStatusBadge = (
  ticket: SupportTicket
): BadgeProps['status'] => {
  const mapped = STATUS_BADGE_MAP[normalizeTicketStatus(ticket.status)]
  if (mapped) return mapped

  return ticket.completed ? 'success' : 'default'
}
